// src/routes/AppRoutes.jsx
import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import Loader from "../components/Loader";
import { routeConfig } from "./config";

const renderRoutes = (routes) => {
  return Object.entries(routes).map(([key, route]) => {
    if (route.children) {
      return (
        <Route key={key} path={route.path} element={<route.component />}>
          {Object.entries(route.children).map(([childKey, child]) => (
            <Route
              key={`${key}-${childKey}`}
              path={child.path}
              element={<child.component />}
            />
          ))}
        </Route>
      );
    }

    return (
      <Route
        key={key}
        path={route.path}
        element={<route.component />}
      />
    );
  });
};

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <Routes>
          {renderRoutes(routeConfig.public)}
          <Route element={<PrivateRoute />}>
            {renderRoutes(routeConfig.private)}
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default AppRoutes;
